/** Custom events the guide rail listens for from real product screens. */

export const GUIDE_EVENT = "dp-guide-event";

export function emitGuideEvent(type, detail = {}) {
  const t = String(type || "").trim();
  if (!t || typeof window === "undefined") return;
  try {
    window.dispatchEvent(
      new CustomEvent(GUIDE_EVENT, {
        detail: { type: t, ...detail },
      })
    );
  } catch {
    /* ignore */
  }
}
